import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", {
      class: "modal d-block",
      style: {"background":"rgba(0,0,0,.55)","z-index":"10500","position":"fixed","top":"0","left":"0","width":"100%","height":"100%"},
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.store.close()), ["self"]))
    }, [
      (_ctx.store.component)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.store.component), _mergeProps({ key: 0 }, _ctx.store.props, {
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.close()))
          }), null, 16))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.isOpen]
    ])
  ]))
}